export default __webpack_public_path__ + "static/media/boulettedeviande.06916ba1.jpg";